module.exports = __webpack_public_path__ + "img/sentenance_logoW (1).f3c8a29a.png";